module.exports = __webpack_public_path__ + "img/shoerackA32.adf74b9d.jpg";